export function useFormatModifier() {
    const formatModifier = (value: number | null | undefined): string => {
        if (value == null) return '—';
        return value > 0 ? `+${value}` : `${value}`;
    };

    return { formatModifier };
}
